import React from 'react';

import ChartingConfiguration from '@/components/charting/ChartingConfiguration';
import { SidebarContainer } from '@/features/dashboard/components/WidgetConfigurationSidebar.styles';
import { QueryMetricsDimensionsConfiguration } from '@/features/queryMetricsDimensionsConfig/components/QueryMetricsDimensionsConfiguration';
import { ConfigurationSectionTitle } from '@/features/dashboard/components/ConfigurationSectionTitle';
import { useDataPresentationParam } from '@/hooks';
import { useConfiguredDataTable } from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { useLoadSteps_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { useSelector } from 'react-redux';
import { getSelectedLayerId } from '@/store-selectors';

export const QueryConfigSidebar: React.FC<{
  showOnboarding: boolean;
}> = ({ showOnboarding }) => {
  const dataPresentation = useDataPresentationParam();
  const dataTable = useConfiguredDataTable();
  const steps = useLoadSteps_LEGACY();
  const selectedStepId = useSelector(getSelectedLayerId);

  if (!dataTable) return null;

  return (
    <SidebarContainer>
      <ConfigurationSectionTitle>Configure chart</ConfigurationSectionTitle>
      <QueryMetricsDimensionsConfiguration />
      <ChartingConfiguration
        layers={steps}
        selectedLayerId={selectedStepId}
        showOnboarding={showOnboarding}
        dataTable={dataTable}
        headings={dataTable.headings()}
        dataPresentation={dataPresentation}
      />
    </SidebarContainer>
  );
};
